import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons'

const SimpleDialog = (props) => {
  const {
    id,
    open = false,
    title,
    onClose,
    children,
    className,
    isLoading = false,
  } = props

  return (
    <Dialog
      id={id}
      open={open}
      onClose={onClose}
      className={className}
      aria-labelledby={id}
    >
      <div className="flex justify-between">
        {title}
        <IconButton
          aria-label="close"
          className="h-full"
          onClick={() => onClose()}
          disabled={isLoading}
          tabIndex={-1}
        >
          <Close fontSize="small" />
        </IconButton>
      </div>

      {children}
    </Dialog>
  )
}

SimpleDialog.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  title: PropTypes.node,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
}

export default SimpleDialog
